export type FooterLayout = 'withSidebar' | 'centerProse' | 'centerCheckout' | 'floating';
export type FooterPriceType = 'STARTING_PRICE' | 'QUOTE_PRICE';

/**
 * Stores state of the footer
 */
export default function useFooterState() {
    const isEnabled = useState<boolean>('footer_is_enabled', () => true);
    const forwardCallback = useState<(() => any) | undefined>('footer_forward_callback', () => undefined);
    const forwardLabel = useState<string>('footer_forward_label', () => '');
    const backwardCallback = useState<(() => any) | undefined>('footer_backward_callback', () => undefined);
    const backwardLabel = useState<string>('footer_backward_label', () => '');
    const layout = useState<FooterLayout>('footer_layout', () => 'withSidebar');
    const isPriceVisible = useState<boolean>('footer_is_price_visible', () => false);
    const price = useState<Price | undefined>('footer_price', () => undefined);
    const priceType = useState<FooterPriceType | undefined>('footer_price_type', () => undefined);
    const canProceed = useState<boolean>('footer_can_proceed', () => false);
    const canGoBack = useState<boolean>('footer_can_go_back', () => true);
    const isProceedDisabledVisually = useState<boolean>('footer_is_proceed_disabled_visually', () => false);
    const isProceedPending = useState<boolean>('footer_is_proceed_pending', () => false);

    return {
        isEnabled,
        forwardLabel,
        forwardCallback,
        backwardCallback,
        backwardLabel,
        layout,
        isPriceVisible,
        price,
        priceType,
        canProceed,
        canGoBack,
        isProceedDisabledVisually,
        isProceedPending,
    };
}
